import React from 'react';
import './BentoSquareSmall.scss';
import { cn } from '../../../utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Button } from '@dataartdev/uikit/Button';
import { Picture } from '@dataartdev/uikit/Picture';
import { WrapperLink } from '../../WrapperLink/WrapperLink';
import { Item } from '../../ContentBuilder/templates/models/CTI_117.props';
import { prepareButtonAttrs } from '../../../utils/prepareButtonAttrs';

export const cnBentoSquareSmall = cn('BentoSquareSmall');

export const BentoSquareSmall: React.FC<Item> = props => {
  const {
    title,
    link,
    subtitle,
    // color,
    // isInverted,
    picture,
  } = props || {};
  const buttonAttrs = prepareButtonAttrs(
    link?.link,
    link?.title,
    link?.targetBlank
  );

  const hasPicture = picture?.url.length > 0;

  return (
    <>
      {/* remove target="_blank" if it's not external. replace a by div if there is no link */}
      <WrapperLink
        className={cnBentoSquareSmall({ hasPicture: hasPicture })}
        url={link?.link}
      >
        <div className={cnBentoSquareSmall('Inner')}>
          {title && (
            <Typography.Title
              as="h3"
              size="sm"
              className={cnBentoSquareSmall('Title')}
            >
              {title}
            </Typography.Title>
          )}
          {subtitle && (
            <Typography.Text
              as="span"
              size="m"
              className={cnBentoSquareSmall('Description')}
            >
              {subtitle}
            </Typography.Text>
          )}
        </div>
        {/* don't put iconRight prop if it's an external link. don't show a button if it's not a link at all */}
        {Object.keys(buttonAttrs).length > 0 && (
          <Button
            className={cnBentoSquareSmall('Button')}
            view="link-secondary"
            iconSize="s"
            {...buttonAttrs}
          />
        )}
        {picture && (
          <Picture className={cnBentoSquareSmall('Img')} {...picture} />
        )}
      </WrapperLink>
    </>
  );
};
